export const Travel = () => {
  return (
    <div className="coming-soon">
      <h1>COMING SOON, IT IS STILL BEING COOKED UP</h1>
    </div>
  );
};
